import { graphql } from 'react-apollo'
import { Layout, Input, Table, Divider, Form, Button, Select, notification } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import eventsQuery from '../graphql/queries/events'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import searchEventQuery from '../graphql/queries/searchEvent'


import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item
const { Option } = Select

const getReference = (label) => {
  switch (label.app) {
    case 'shop': return label.referenceId
    case 'race': return label.data.bibs.join(', ')
    case 'inbox': return label.referenceId
    default: return '-'
  }
}

class searchEvent extends Component {
  state = {
    submitting: false,
    labels: [],
  }

  loadLabels = async () => {
    this.setState({ submitting: true })
    const id = this.props.form.getFieldValue('eventName')
    try {
      if (id) {
        const { data: { labels } } = await this.props.labels.refetch({ event: id })
        this.setState({ labels })
      }
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.message,
      })
    } finally {
      this.setState({ submitting: false })
    }
  }
  handleInputChange = (e) => {
    const { setFieldsValue } = this.props.form
    setFieldsValue({ [e.target.name]: e.target.value })
    this.setData(this.state.rows)
  }
  handleSelectChange = (value) => {
    const { setFieldsValue } = this.props.form
    setFieldsValue({ app: value })
    setFieldsValue({ maxItems: 3 })
    this.setData(this.state.rows)
  }
  handleSelectAddressChange = (value) => {
    const { setFieldsValue } = this.props.form
    setFieldsValue({ type: value })
    if (value === 'old') {
      setFieldsValue({ maxItems: 1 })
    } else {
      setFieldsValue({ maxItems: 3 })
    }
    this.setData(this.state.rows)
  }
  handleSearchEventChange = (e) => {
    const { setFieldsValue } = this.props.form
    setFieldsValue({ searchEvent: e.target.value })
    this.handleSelectEventChange(0)
  }
  handleSelectEventChange = (value) => {
    const { events: { events } } = this.props
    const { getFieldValue, setFieldsValue } = this.props.form
    const searchEvent = getFieldValue('searchEvent')
    const num = parseInt(value, 10)
    const filteredEvents = events.filter(val => val.name.match(new RegExp(searchEvent, 'igu')))
    const event = filteredEvents[num]
    if (event) {
      setFieldsValue({ event: num, eventName: event.name, eventCode: event.code })
    }
  }

  render() {
    const { events: { loading, events } } = this.props
    const { getFieldDecorator, getFieldValue } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Group',
        dataIndex: 'group',
        key: 'group',
        width: 150,
      },
      {
        title: 'Label ID',
        key: 'labelId',
        width: 100,
        className: 'text-center',
        render: record => (<span>{record._id}<br />({record.app})</span>),
      },
      {
        title: 'Reference',
        key: 'reference',
        width: 100,
        className: 'text-center',
        render: getReference,
      },
      {
        title: 'Recipient',
        dataIndex: 'recipient',
        key: 'recipient',
        width: 150,
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: 'Count',
        key: 'count',
        width: 60,
        className: 'text-center',
        render: record => record.data.count,
      },
      {
        title: 'Items',
        key: 'item',
        width: 200,
        /* eslint react/no-array-index-key: 0 */
        render: record => (
          <ul style={{ paddingLeft: '20px' }}>
            {record.data.items && record.data.items.map(item => (
              <li key={`${record.referenceId} ${item.name}`}>[{item.amount}] {item.name}</li>
            ))}
            {record.data.shirts && record.data.shirts.map((shirt, index) => (
              <li key={`${record.referenceId} ${shirt} ${index}`}>{shirt}</li>
            ))}
          </ul>
        ),
      },
      {
        title: 'Tracking',
        key: 'tracking',
        width: 100,
        className: 'text-center',
        render: record => (record.tracking ? <span>[{record.tracking.carrier}]<br />{record.tracking.code}</span> : '-'),
      },
    ]
    return (
      <Layout>
        <Navbar selected="search:7" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form onSubmit={this.handleSubmit}>
                <div>
                  <FormItem
                    {...formItemLayout}
                    label="Search event"
                  >
                    {getFieldDecorator('searchEvent', {
                      initialValue: '',
                      rules: [{ message: 'Search event by name' }],
                    })(
                      <Input type="text" name="searchEvent" onChange={this.handleSearchEventChange} />
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label="Event"
                  >
                    {getFieldDecorator('event', {
                      initialValue: 0,
                      rules: [{ required: true, message: 'Please select your event!' }],
                    })(
                      <Select
                        placeholder="Select your event"
                        onChange={this.handleSelectEventChange}
                      >
                        {!loading && events && events.filter(val => val.name.match(new RegExp(`${getFieldValue('searchEvent')}`, 'igu'))).map((event, index) => (
                          <Option key={event.slug} value={index}>{event.name} ({event.code})</Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label="Event name"
                  >
                    {getFieldDecorator('eventName', {
                      initialValue: ((events && events[0].name) || ''),
                    })(
                      <Input type="text" name="eventName" onChange={this.handleInputChange} disabled />
                    )}
                  </FormItem>
                </div>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={this.loadLabels} disabled={this.state.submitting}>Search</Button>
              </FormItem>
            </Form>
            <Divider />
            {this.state.labels.length > 0 ? (
              <div>
                <h2>Labels</h2>
                <Table
                  rowKey="_id"
                  dataSource={this.state.labels}
                  columns={columns}
                  pagination={{ pageSize: 50 }}
                  size="small"
                />
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
searchEvent.propTypes = {
  form: PropTypes.shape(),
}
searchEvent.defaultProps = {
  form: {},
}

export default graphql(searchEventQuery, { name: 'labels', options: { variables: { event: '' } } })(graphql(eventsQuery, { name: 'events' })(Form.create()(searchEvent)))



// WEBPACK FOOTER //
// ./src/pages/SearchEvent.js